/** BroadcastChannel key — keeps My Vendors query in sync across open tabs. */
export const MY_VENDORS_BROADCAST_CHANNEL = "dqp-my-vendors-sync";

export function broadcastMyVendorsChanged(sponsorId) {
  if (typeof BroadcastChannel === "undefined" || !sponsorId) return;
  const channel = new BroadcastChannel(MY_VENDORS_BROADCAST_CHANNEL);
  channel.postMessage({ sponsorId: String(sponsorId), ts: Date.now() });
  channel.close();
}
